import * as types from "./types";
import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CURRENT_SECTION_INDEX:
      return {
        ...state,
        currentSectionIndex: action.payload,
      };
    case types.SET_IS_SUBMIT_CLICKED:
      return {
        ...state,
        is_submit_clicked: action.payload,
      };
    case types.ADJUST_DRILLED_DOWN_COUNT_BY:
      return {
        ...state,
        drilledDownCount: state.drilledDownCount + action.payload,
      };
    case types.SET_CURRENT_SECTION:
      return {
        ...state,
        shouldShowAnswer: false,
        sectionStack: [...state.sectionStack, action.payload],
      };
    case types.REMOVE_CURRENT_SECTION:
      const sectionStack = state.sectionStack;
      return {
        ...state,
        sectionStack: sectionStack.slice(0, sectionStack.length - 1),
      };
    case types.SHOW_CORRECT_ANSWER:
      return { ...state, shouldShowAnswer: true };
    case types.STORE_AUTO_SELECTED:
      const { selectedAfterSectionId, autoSelectedQuestionId } = action.payload;
      return {
        ...state,
        autoSelected: {
          ...state.autoSelected,
          [selectedAfterSectionId]: autoSelectedQuestionId,
        },
      };

    default:
      return state;
  }
};
